import { FC } from 'react'
import { unstable_useBlocker as useBlocker } from 'react-router-dom'

import { Widget } from '@factorialco/f0-react/dist/experimental'
import { ShiftsInsightDocument, ShiftsInsightQuery } from 'generated/resources/graphql'
import moment from 'moment'

import CalendarEventList from 'modules/core/components/CalendarEventList'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'
import { buildWidget } from 'modules/core/lib/widgets'

const prepareData = (data: ShiftsInsightQuery) => {
  const planningVersions =
    data?.shiftManagement.employeesPermissionsConnection.nodes[0]?.planningVersionsConnection
      .nodes || []
  const currentPlanningTool = [...planningVersions].sort((a, b) =>
    moment(b.effectiveAt, 'YYYY-MM-DD').diff(moment(a.effectiveAt, 'YYYY-MM-DD'))
  )[0]?.planningTool

  if (currentPlanningTool !== 'shift_management') return { items: [] }

  const items = data?.shiftManagement.shiftsConnection.nodes || []

  return {
    items,
  }
}

type PreparedData = ReturnType<typeof prepareData>

const ShiftsWidgetComponent: FC<{
  data: PreparedData
  employeeId: string
  onClickWidget?: () => void
}> = ({ data: { items }, onClickWidget }) => {
  const { navigation } = useNavigation()

  const linkUrl = navigation.shifts.fullPath()

  useBlocker(({ nextLocation }) => {
    if (linkUrl.endsWith(nextLocation.pathname)) {
      onClickWidget?.()
    }
    return false
  })

  return (
    <Widget
      header={{
        title: i18n.t('insights.widgets.shifts.title'),
        subtitle: i18n.t('insights.widgets.shifts.subtitle'),
        link: {
          title: i18n.t('insights.widgets.shifts.title'),
          url: linkUrl,
        },
      }}
    >
      <CalendarEventList items={items} />
    </Widget>
  )
}

export const buildShiftsWidget = () =>
  buildWidget({
    id: 'shifts',
    document: ShiftsInsightDocument,
    prepareData,
    isEmpty: ({ items }) => items.length === 0,
    component: ShiftsWidgetComponent,
  })
